import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import { HaulerCustomer } from '../entities/HaulerCustomer'

@InputType()
export class GetNearbyCustomersArgs extends ActionArgs {
  @Field(() => [Float])
  epicenter: number[]

  @Field(() => Float)
  maxDistance: number
}

@ObjectType()
@InputType('NearbyCustomerResultInput')
export class NearbyCustomerResult {
  @Field(() => HaulerCustomer)
  customer: HaulerCustomer

  @Field(() => Float)
  distance: number
}
